import styled, { Theme } from '@themes/theme'
import { css, keyframes } from '@emotion/core'
import { SafeAreaConstantPadding, SafeAreaEnvPadding, TxtLimit } from '@styles/base.style'

export const LightBgEffectAni = keyframes`
  0%, 55%, 100% {
    opacity: .3;
  }
  18%{
    opacity: 1;
  }
`
export const LightBgEffectAni2 = keyframes`
  0%, 55%, 100% {
    opacity: .15;
  }
  18%{
    opacity: .5;
  }
`
export const LightSpotCircleEffectAni = keyframes`
  0%, 30%, 100% {
    opacity: .1;
  }
  60%  {
    opacity: 1;
  }
`
export const LightEffectAni = keyframes`
  0% {
    transform: rotate(-115deg);
  }
  28% , 100%  {
    transform: rotate(245deg);
  }
`
export const LightCircleEffectAni = keyframes`
  0%, 100% {
    opacity: .2;
  }
  20%  {
    opacity: 1;
  }
`

export const SelectedLeague = styled.div`
  position:relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 83%;
  width: auto;
  height: 30px;
  margin-left: 14px;
  padding: 0 4px 0 10px;
  border-radius: 50px;
  background: ${props => props.theme.color.modalBg};
  .quick-selected-league-emblem {
    width: auto;
    height: 18px;
  }
  .quick-selected-league-name {
    ${TxtLimit};
    flex: 1;
    margin: 0 9px 0 4px;
    color: ${props=>props.theme.color.modalTxt};
  }
  .quick-selected-league-btn {
    z-index: 0;
    position: relative;
    right: 0;
    width: 23px;
    height: 23px;
    border-radius: 50%;
    background: ${props=>props.theme.color.modalSubBg};
    &::before {
      transform: rotate(45deg) scale(0.8);
    }
    &::after {
      transform: rotate(-45deg) scale(0.8);
    }
    &::before, &::after {
      left: 6px;
      width: 12px;
      background: ${props=>props.theme.color.modalTxt};
      border-radius: 5px;
    }
  }
  // 나도승부사 경기분석 유저필터
  &.user-pick-filter {
      max-width: 100%;
      margin-left: 0;
  }
`

const aniTime = '3.5s'

export const BaccaratBtnStyle = css`
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-60%);
  width: auto;
  height: 42px;
  background: #1c202b;
  .effect-bg {
    z-index: -1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background: radial-gradient(#5422c8, #1c202b 67%);
    border-radius: 50%;
    animation: ${LightBgEffectAni} ${aniTime} infinite;
    &.pink {
      width: 25px;
      height: 25px;
      background: radial-gradient(#ff00b8, #1c202b 80%);
      opacity: .45;
      animation: ${LightBgEffectAni2} ${aniTime} infinite;
    }
  }
  img {
    image-rendering: -webkit-optimize-contrast;
  }
  .effect-box {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 26px;
    overflow: hidden;
    mix-blend-mode: color-dodge;
    .circle-line {
      position: relative;
      top: 4px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      transform: rotate(-150deg);
      animation: ${LightEffectAni} ${aniTime} infinite cubic-bezier(.22,.67,.85,.22);
      .light-ani {
        position: relative;
        top: 0;
        left: -4px;
        display: block;
        width: 18px;
        height: 10px;
        border-radius: 50%;
        transform: rotate(-42deg);
        background: radial-gradient(#d1d4ff, #000 85%);
        animation: ${LightCircleEffectAni} ${aniTime} infinite;
      }
    }
  }
`
export const GuideBtnStyle = css`
  position: fixed;
  bottom: 90px;
  left: 10px;
  width: auto;
  height: 54px;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  z-index: 2;
  img {
    width: auto;
    height: inherit;
  }
  &.pc {
    position: static;
    margin: 15px 10px 15px 0;
    float: right;
    width: auto;
    height: 30px;
  }
`
export const EtcBubbleWrap = styled.div`
  position: absolute;
  bottom: 85%;
  right: 21px;
  width: auto;
  height: 34px;
  text-align: center;
  &:not(.pc) {
    right: calc(6px + 7%);
    transform: translateX(50%);
  }
  img {
    width: auto;
    height: inherit;
  }
`
export const GameTabWrap = styled.div`
  height: 42px;
  display: flex;
  align-items: center;
`
export const MatchResultBtnStyle = (theme: Theme) => css`
  position: relative;
  //margin-right: auto;
  padding: 0 11px;
  .btn-txt {
    font-size: 17px;
  }
  ::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    width: 1px;
    height: 16px;
    transform: translateY(-53%);
    border-left: 1px solid #506070;
    opacity: .7;
  }
`
export const MathUpClubMarkImgStyle = (theme: Theme) => css`
  display: none;
  position: absolute;
  width: 86px;
  height: auto;
  top: -16px;
  right: 16px;
  &.pc {
    right: 20px;
  }
`
